export const colorTokens = {
  // Brand greens
  green100: '#437943',
  green200: '#2d5c2d',
  green300: '#649264',
  green400: '#84ac85',
  green500: '#a5c5a6',
	green900: 'rgb(20, 39, 27)',

	// Brand Purple
	purple100: '#7302b8',

  // Neutrals
  slate900: '#1A202C',
  slate700: '#2D3748',
  slate600: '#4A5568',
  slate500: '#5A6878',
  slate400: '#718096',
  slate300: '#A0AEC0',
  slate200: '#E2E8F0',
  slate150: '#EDF2F7',
  slate100: '#F7FAFC',
  slate50: '#F8FAFC',
  white: '#FFFFFF',

  // Accent
  darkSlate: '#252D3D',
  blueHeader: '#1E476D',

  // Semantic
  errorMain: '#C53030',
  errorDark: '#9B2C2C',
  darkRed: '#e60000',
}

export const borderRadiusTokens = {
  control: 8, // buttons, inputs, selects, chips, alerts, accordions, menus
  surface: 12, // Paper, Card, Dialog, DataCard
}

export const controlHeightTokens = {
  small: 32,
  medium: 40, // matches TextField outlined/small
  large: 48,
}

// Box-shadows are intentionally disabled across the app. Surfaces rely on the
// background.paper colour + a slate200 border for separation instead.
export const shadowTokens = {
  card: 'none',
  cardHover: 'none',
  sidebar: 'none',
  navigation: 'none',
}

export const spacingTokens = {
  sidebarWidth: 280,
  sidebarCollapsedWidth: 64,
  contentPadding: 24,
  cardPadding: 24,
  navigationItemHeight: 48,
  pageMargin: 24,
  cardGap: 16,
  sectionGap: 32,
  elementGap: 8,
}

export const animationTokens = {
  sidebarTransition: 'width 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms',
  navigationTransition: 'all 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
  cardTransition:
    'box-shadow 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
  hoverTransition: 'background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
}
